const MIN_NAME_LENGTH = 4;
const MAX_NAME_LENGTH = 46;
const NAME_ALLOWED = /^[A-Za-z0-9 !@#$%^&*()_+{}:"<>?±-]*$/;

// Trim ends and collapse internal space runs to a single space so padding with
// spaces can't inflate the character count or persist to the DB. Only literal
// spaces are collapsed — other whitespace (tabs, newlines) is left intact so
// NAME_ALLOWED still rejects it rather than silently rewriting the name.
export const normalizeCampaignName = (value: string): string => value.trim().replace(/ +/g, " ");

export const validateCampaignName = (value: string): string | null => {
  const normalized = normalizeCampaignName(value);
  if (normalized.length === 0) {
    return "Campaign name is required";
  }
  if (normalized.length < MIN_NAME_LENGTH) {
    return "Campaign name is too short (minimum 4 characters)";
  }
  if (normalized.length > MAX_NAME_LENGTH) {
    return "Campaign name should not exceed 46 characters";
  }
  if (!NAME_ALLOWED.test(normalized)) {
    return "Campaign name contains invalid characters.";
  }
  return null;
};
